export default "__VITE_ASSET__BKs$CNYZ__"